import moment from 'moment';

import { Box, Text } from '@frontend/components';
import { useDateFormat } from '@frontend/utils';

import { toReadableString } from 'utils/stringUtils';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import ValueText from './ValueText';

const PaddedCell = ({ children }) => (
  <td style={{ paddingRight: '8px' }}>{children}</td>
);

const OrderMatchCell = ({ orderResult }) => {
  const { dateAtTimeFormat } = useDateFormat();
  return (
    <Box
      as="a"
      href={`/orders/edit/${orderResult.data.number}`}
      display="block"
      width="100%"
      height="100%"
      transition="0.2s ease"
      _hover={{
        bg: 'interaction.surfaceHover',
      }}
      _focus={{
        boxShadow: 'focusInset',
      }}
      _active={{
        bg: 'interaction.surfaceActive',
      }}
      padding={1}
    >
      <table style={{ borderCollapse: 'collapse' }}>
        <tr>
          <PaddedCell>
            <Text
              fontFamily="data"
              fontSize="sm"
              fontWeight="heavy"
              color="feature.primary"
              whiteSpace="nowrap"
            >
              {`Order #`}
              <HighlightOrDisplay
                result={orderResult}
                field="number"
                textProps={{ fontWeight: 'heavy' }}
                useDataFont
              />
            </Text>
          </PaddedCell>
          <td>
            <LabelText>{toReadableString(orderResult.data.status)}</LabelText>
          </td>
        </tr>
        <tr>
          <PaddedCell>
            <LabelText>CONTACT</LabelText>
          </PaddedCell>
          <td>
            <HighlightOrDisplay result={orderResult} field="accountName" />
          </td>
        </tr>
        <tr>
          <PaddedCell />
          <td>
            <HighlightOrDisplay result={orderResult} field="contactFullName" />
          </td>
        </tr>
        <tr>
          <PaddedCell />
          <td>
            <HighlightOrDisplay result={orderResult} field="contactEmail" />
          </td>
        </tr>
        <tr>
          <PaddedCell>
            <LabelText>PAY METHOD</LabelText>
          </PaddedCell>
          <td>
            <ValueText>
              {orderResult.data.paymentMethod
                ? toReadableString(orderResult.data.paymentMethod)
                : '--'}
            </ValueText>
          </td>
        </tr>
        <tr>
          <PaddedCell>
            <LabelText>PRICE</LabelText>
          </PaddedCell>
          <td>
            <ValueText useDataFont>
              {orderResult.data.totalPrice ? orderResult.data.totalPrice : '--'}
            </ValueText>
          </td>
        </tr>
        <tr>
          <PaddedCell>
            <LabelText>ORDERED</LabelText>
          </PaddedCell>
          <td>
            <ValueText useDataFont>
              {orderResult.data.created
                ? moment(orderResult.data.created)
                    .subtract(new Date().getTimezoneOffset(), 'minutes')
                    .format(dateAtTimeFormat)
                : '--'}
            </ValueText>
          </td>
        </tr>
        <tr>
          <PaddedCell>
            <LabelText>SHIPS</LabelText>
          </PaddedCell>
          <td>
            <ValueText useDataFont>
              {orderResult.data.shipsOn
                ? orderResult.data.shipsOn
                    .map((shipsOnDate) =>
                      moment(shipsOnDate)
                        .subtract(new Date().getTimezoneOffset(), 'minutes')
                        .format(dateAtTimeFormat),
                    )
                    .join(', ')
                : '--'}
            </ValueText>
          </td>
        </tr>
      </table>
    </Box>
  );
};

export default OrderMatchCell;
